// Identidade visual do GroupFaces, extraída de groupfaces.front/app/assets/css/main.css:
// dark estilo Linear, neutros "graphite", um acento só ("linear" #7170ff), Inter nos títulos e no corpo,
// JetBrains Mono em números, rótulos e IDs. Sem serifa: a ênfase é por cor e peso, não por fonte.
import {staticFile} from 'remotion';

export const FPS = 24;

export const C = {
 bg: '#08090a',           // --ui-bg
 bgMuted: '#0f1011',      // --ui-bg-muted
 card: '#191a1b',         // --ui-bg-elevated
 cardHi: '#28282c',       // --ui-bg-accented
 ink: '#f7f8f8',          // --ui-text-highlighted
 ink2: '#d0d6e0',         // --ui-text
 muted: '#8a8f98',        // --ui-text-muted
 line: 'rgba(255,255,255,0.08)',
 lineHi: 'rgba(255,255,255,0.14)',
 accent: '#7170ff',       // linear-400
 accentHi: '#828fff',     // linear-300
 accentDeep: '#5e6ad2',   // linear-500
 accentInk: '#14163a',    // linear-950
 green: '#4cb782',
 amber: '#f2c94c',
 red: '#eb5757',
};

export const F = {
 sans: 'Inter, system-ui, sans-serif',
 mono: 'JetBrainsMono, ui-monospace, monospace',
};

const f = (n: string) => staticFile('fonts/' + n);
export const fontCSS = `
@font-face{font-family:Inter;src:url('${f('inter-wght.woff2')}') format('woff2');font-weight:100 900;unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}
@font-face{font-family:Inter;src:url('${f('inter-ext-wght.woff2')}') format('woff2');font-weight:100 900;unicode-range:U+0100-024F,U+0259,U+1E00-1EFF,U+2020,U+20A0-20AB,U+20AD-20CF,U+2113,U+2C60-2C7F,U+A720-A7FF}
@font-face{font-family:JetBrainsMono;src:url('${f('jbmono-wght.woff2')}') format('woff2');font-weight:100 800}
`;
export const FONT_LOADS = ['400 40px Inter', '500 40px Inter', '600 100px Inter', '700 100px Inter', '400 16px JetBrainsMono', '500 16px JetBrainsMono'];

// Linguagem de movimento (a mesma do tutorial Valsa): smootherstep na câmera, no cursor e na rolagem;
// easeOutQuart nas entradas. Nada de overshoot nem rotação — este produto pede precisão, não energia.
export const ease = (t: number) => {t = Math.max(0, Math.min(1, t)); return t * t * t * (t * (t * 6 - 15) + 10)};
export const easeOut = (t: number) => {t = Math.max(0, Math.min(1, t)); return 1 - Math.pow(1 - t, 4)};
export const sec = (s: number) => Math.round(s * FPS);
export const lerp = (a: number, b: number, k: number) => a + (b - a) * k;
// janela de vida de um elemento: entra em `a`, sai em `b`, com rampas de `inn` e `out` segundos
export const life = (t: number, a: number, b: number, inn = 0.5, out = 0.35) =>
 Math.min(easeOut((t - a) / inn), 1 - ease((t - (b - out)) / out));

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
